import { Injectable } from '@angular/core';
import { UserService } from './user-service';
import { Person } from '../models/entities/master-data/person-entity';
import { PersonRequest } from '../models/dtos/master-data/person-request';
import { PartnerSite } from '../models/entities/control-tables/partner-site-entity';
import { Itinerary } from '../models/entities/master-data/itinerary-entity';
import { ItineraryRequest } from '../models/dtos/control-tables/itinerary-request';
import { Partner } from '../models/entities/master-data/partner-entity';
import { PartnerRequest } from '../models/dtos/master-data/partner-request';
import { PartnerSiteRequest } from '../models/dtos/control-tables/partner-site-request';
import { Role } from '../models/entities/master-data/role-entity';
import { RoleRequest } from '../models/dtos/master-data/role-request';
import { Product } from '../models/entities/master-data/product-entity';
import { ProductRequest } from '../models/dtos/master-data/product-request';
import { ProductOption } from '../models/entities/master-data/product-option-entity';
import { ProductOptionRequest } from '../models/dtos/control-tables/product-option-request';
import { PriceList } from '../models/entities/master-data/price-list-entity';
import { PriceListRequest } from '../models/dtos/master-data/price-list-request';
import { LeanNetworkService } from 'src/app/tools/services/lean-network-service';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { ProductPage } from '../models/entities/control-tables/product-page';


@Injectable({
  providedIn: 'root'
})
export class MasterDataService {

  constructor(
    public userService : UserService,
    private networkService : LeanNetworkService) { }



//------------------------------------------------------------------------------------
//                        ROLE
//------------------------------------------------------------------------------------
rolesGet(roleCode? : string, name? : string, branchCode? : string): Promise<Role[]> {
      let request: BaseRequest = new BaseRequest(this.userService.userInfo);

      request.strArg1 = roleCode;
      request.strArg2 = name;
      request.strArg3 = branchCode;

      return new Promise((resolve) => {
          this.networkService.post('kernel/masters/rolesGet', request).then(result => {
              return resolve(result.roles);
          });
      });
    }

    roleGet(roleCode : string): Promise<Role> {
        let request: BaseRequest = new BaseRequest(this.userService.userInfo);
        request.code = roleCode;

        return new Promise((resolve) => {
            this.networkService.post('kernel/masters/roleGet', request).then(result => {
                return resolve(result.role);
            });
        });
    }
  

    roleSave(role : Role) : Promise<Role>{
      let request: RoleRequest = new RoleRequest(this.userService.userInfo);
      request.role = role;
  
      return new Promise((resolve, reject) => {
          this.networkService.post('kernel/masters/roleSave', request).then(result => {
              let role : Role = result.role;
              return resolve(role);         
          }, error => {
              reject(error);
          });
      });
    }



//------------------------------------------------------------------------------------
//                      PERSON
//------------------------------------------------------------------------------------

    personsGet(code : string, name : string, profileCode : string): Promise<Person[]> {
      let request         : BaseRequest = new BaseRequest(this.userService.userInfo);
      request.strArg1 = code;
      request.strArg2 = name;
      request.strArg3 = profileCode;
      
      return new Promise((resolve, reject) => {
          this.networkService.post('kernel/masters/personsGet', request).then(result => {
            return resolve(result.persons);
          }, error => {
              reject(error);
          });
      });
    }
  
    personSave(person : Person) : Promise<Person>{
      let request: PersonRequest = new PersonRequest(this.userService.userInfo);
      request.person = person;
  
      return new Promise((resolve, reject) => {
          this.networkService.post('kernel/masters/personSave', request).then(result => {
              let person : Person = result.person;
              return resolve(person);         
          }, error => {
              reject(error);
          });
      });
    }  

    personRoleGet(profileCategoryCode : string ): Promise<Role> {
      let request: BaseRequest = new BaseRequest(this.userService.userInfo);
      request.strArg1 = this.userService.userInfo.person.personCode;
      request.strings = [];
      request.strings.push(profileCategoryCode);

      return new Promise((resolve, reject) => {
          this.networkService.post('kernel/masters/personRoleGet', request).then(result => {
              return resolve(result.role);
          }, error => {
              reject(error);
          });
      });
    }
 //------------------------------------------------------------------------------------

 


//------------------------------------------------------------------------------------
//                      ITINERARY
//------------------------------------------------------------------------------------
  
itinerarysGet(code: string, name: string, branchCode : string): Promise<Itinerary[]>  {
    let request         : BaseRequest = new BaseRequest(this.userService.userInfo);
    request.strArg1 = code;
    request.strArg2 = name;
    request.strArg3 = branchCode;
    
    return new Promise((resolve, reject) => {
        this.networkService.post('kernel/masters/itinerarysGet', request).then(result => {
          return resolve(result.itinerarys);
        }, error => {
            reject(error);
        });
    });
  }

  itineraryGet(code: string): Promise<Itinerary>  {
    let request         : BaseRequest = new BaseRequest(this.userService.userInfo);
    request.strArg1 = code;
    
    return new Promise((resolve, reject) => {
        this.networkService.post('kernel/masters/itineraryGet', request).then(result => {
          return resolve(result.itinerary);
        }, error => {
            reject(error);
        });
    });
  }

  itinerarySave(itinerary : Itinerary) : Promise<Itinerary>{
    let request: ItineraryRequest = new ItineraryRequest(this.userService.userInfo);
    request.itinerary = itinerary;

    return new Promise((resolve, reject) => {
        this.networkService.post('kernel/masters/itinerarySave', request).then(result => {
            let itinerary : Itinerary = result.itinerary;
            return resolve(itinerary);           
          }, error => {
            reject(error);
        });
    });
  }

  

//------------------------------------------------------------------------------------
//                      PARTNER
//------------------------------------------------------------------------------------
partnersGet(    
    code                  : string,
    branchCode            : string,
    itineraryCode         : string,
    name                  : string, 
    partnerCategoryCode   : string,
    salesChannelCode      : string,
    partnerStatusCode     : string,
    progressLevel         : number,
    page                  : number): Promise<any> {

    let request         : BaseRequest = new BaseRequest(this.userService.userInfo);
    request.strArg1 = code;
    request.strArg2 = branchCode;
    request.strArg3 = itineraryCode;
    request.strArg4 = name;
    request.strArg5 = salesChannelCode;
    request.strArg6 = partnerCategoryCode;
    request.strArg7 = partnerStatusCode;
    request.lngArg1 = progressLevel;
    request.page    = page;
 
          
        return new Promise((resolve, reject) => {
            this.networkService.post('kernel/masters/partnersGet', request).then(result => {
              return resolve(result);
            }, error => {
                reject(error);
            });
        });
  }

  partnerGet(partnerCode : string) : Promise<Partner>{
    let request: BaseRequest = new BaseRequest(this.userService.userInfo);
    request.code = partnerCode;

    return new Promise((resolve, reject) => {
        this.networkService.post('kernel/masters/partnerGet', request).then(result => {
            let partner : Partner = result.partner;
            return resolve(partner);           
        }, error => {
            reject(error);
        });
    });
  }
  

  partnerSave(partner : Partner) : Promise<Partner>{
    let request: PartnerRequest = new PartnerRequest(this.userService.userInfo);
    request.partner = partner;

    return new Promise((resolve, reject) => {
        this.networkService.post('kernel/masters/partnerSave', request).then(result => {
            let partner : Partner = result.partner;
            return resolve(partner);           
        }, error => {
            reject(error);
        });
    });
  }




  //------------------------------------------------------------------------------------
  // PartnersSite Get
  //------------------------------------------------------------------------------------
  partnerSitesGet(partnerCode : string): Promise<PartnerSite[]> {
    let request         : BaseRequest = new BaseRequest(this.userService.userInfo);

    request.strArg1 = partnerCode;
    
    return new Promise((resolve, reject) => {
        this.networkService.post('kernel/masters/partnerSitesGet', request).then(result => {
          return resolve(result.partnerSites);
        }, error => {
            reject(error);
        });
    });
  }

  partnerSiteGet(partnerCode : string, partnerSiteCode : string): Promise<PartnerSite> {
    let request         : BaseRequest = new BaseRequest(this.userService.userInfo);

    request.strArg1 = partnerCode;
    request.strArg2 = partnerSiteCode;
    
    return new Promise((resolve, reject) => {
        this.networkService.post('kernel/masters/partnerSiteGet', request).then(result => {
          return resolve(result.partnerSite);
        }, error => {
            reject(error);
        });
    });
  }

  partnerSiteSave(partnerSite : PartnerSite) : Promise<PartnerSite>{
    let request: PartnerSiteRequest = new PartnerSiteRequest(this.userService.userInfo);
    request.partnerSite = partnerSite;

    return new Promise((resolve, reject) => {
        this.networkService.post('kernel/masters/partnerSiteSave', request).then(result => {
            let partnerSite : PartnerSite = result.partnerSite;
            return resolve(partnerSite);         
        }, error => {
            reject(error);
        });
    });
  } 


  partnersSitesAssetsGet(
        partnerCode     : string,
        partnerSiteCode : string,
        assetCode       : string) : Promise<Partner[]>{  
    let request  : BaseRequest = new BaseRequest(this.userService.userInfo);
    request.strArg1 = partnerCode;
    request.strArg2 = partnerSiteCode;
    request.strArg3 = assetCode;

    return new Promise((resolve, reject) => {
        this.networkService.post('kernel/masters/partnersSitesAssetsGet', request).then(result => {
            return resolve(result.partners);        
        }, error => {
            reject(error);
        });
    });
  }
//------------------------------------------------------------------------------------
prospectValidate(partnerCode : string) : Promise<Partner>{
    let request: BaseRequest = new BaseRequest(this.userService.userInfo);
    request.strArg1 = partnerCode;

    return new Promise((resolve, reject) => {
        this.networkService.post('kernel/masters/prospectValidate', request).then(result => {
            let partner : Partner = result.partner;
            return resolve(partner);           
        }, error => {
            reject(error);
        });
    });
  }

//------------------------------------------------------------------------------------





//------------------------------------------------------------------------------------
//                      PRODUCT
//------------------------------------------------------------------------------------
  
salableProductPages        : ProductPage[] = [];
salableProductPagesLoad    : boolean = false;
loadProductPages(qNumber : number, withStock : boolean) : Promise<boolean>{
    return new Promise((resolve, reject) => {

            if (this.salableProductPagesLoad) {

            //----------------------------------------------------
                for (let pp of this.salableProductPages) {
                    pp.expand = false;
                    for (let product of pp.products) {
                        this.initProductQuatities(product, qNumber);
                    }
                }
            //----------------------------------------------------
  
            //----------------------------------------------------
                if (! withStock)   {
                    resolve(true);
                } else {
                    this.productsStockGet().then(productsStock => {
                        for (let pp of this.salableProductPages) {
                             for (let product of pp.products) {
                                let productStock : Product = productsStock.find(tmp => (tmp.productCode == product.productCode) );
                                if (productStock) {
                                    product.availableQuantity   = productStock.availableQuantity;     
                                    product.damagedQuantity1    = productStock.damagedQuantity1;     
                                    product.damagedQuantity2    = productStock.damagedQuantity2;     
                                } else {
                                    product.availableQuantity   = 0;     
                                    product.damagedQuantity1    = 0;     
                                    product.damagedQuantity2    = 0;                                    
                                }
                            }
                        }
                        resolve(true);
                    });
                }
            //----------------------------------------------------
                
                return;
            };

            this.productsGet(null, null, null, null, true, false, withStock).then(products => {
                let productPage : ProductPage = new ProductPage();
                products.forEach( product => {
                this.initProductQuatities(product, qNumber);
                if (product.productPage.productPageCode != productPage.productPageCode){
                    productPage = product.productPage;
                    productPage.expand = false;
                    productPage.products = [];
                    this.salableProductPages.push(productPage);
                }
                productPage.products.push(product);
                });

                /*
                this.priceListGet(priceListCode, true).then(priceList => {
                    products.forEach( product => {
                        priceList.priceListLines.forEach( priceListLine => {
                            for(let priceListLineDetail of priceListLine.priceListLineDetails){
                                if (priceListLineDetail.product.productCode == product.productCode){
                                    product.salesPrice = priceListLineDetail.salesPrice;
                                    product.purchasePrice = priceListLineDetail.salesPrice;
                                    break;
                                }
                            }   
                        })
                    })
                }, error => {
                    reject(error);
                });
                */
                resolve(true);
                this.salableProductPagesLoad = true;
            }, error => {
                reject(error);
            });
    });
}

initProductQuatities(product : Product, qNumber : number) {
    product.rate       = [];
    product.quantityL  = [];
    product.quantityP  = [];
    product.quantityU  = [];
    for (let i = 0; i<qNumber; i++) {
        product.quantityL.push(undefined);
        product.quantityP.push(undefined);
        product.quantityU.push(undefined);
    }
}


productsGet(productCode? : string, name? : string, productPageCode? : string, brandCode? : string, salableOnly? : boolean, includingHold ? : boolean, withStock? : boolean, warehouseCode? : string): Promise<Product[]> {
      let request: BaseRequest = new BaseRequest(this.userService.userInfo);

      request.strArg1 = productCode;
      request.strArg2 = productPageCode;
      request.strArg3 = name;
      request.strArg4 = brandCode;
      request.strArg5 = warehouseCode;

      request.blnArg1 = salableOnly;
      request.blnArg2 = includingHold;
      request.blnArg3 = withStock;

      return new Promise((resolve, reject) => {
          this.networkService.post('kernel/masters/productsGet', request).then(response => {
              resolve(response.products)
          }, error => {
              reject(error);
          });
      });
  }

  productsStockGet(warehouseCode? : string): Promise<Product[]> {
    let request: BaseRequest = new BaseRequest(this.userService.userInfo);
    request.code = warehouseCode;
    
    return new Promise((resolve, reject) => {
        this.networkService.post('kernel/masters/productsStockGet', request).then(response => {
            resolve(response.products)
        }, error => {
            reject(error);
        });
    });
}

  productGet(id: number): Promise<Product> {
      let request: BaseRequest = new BaseRequest(this.userService.userInfo);

      request.id = id;
      request.blnArg1 = true;

      return new Promise((resolve, reject) => {
          this.networkService.post('kernel/masters/productGet', request).then(response => {
              resolve(response.product)
          }, error => {
              reject(error);
          });
      });
  }

  productGetByCode(productCode: string): Promise<Product> {
    let request: BaseRequest = new BaseRequest(this.userService.userInfo);

    request.strArg1 = productCode;
    request.blnArg1 = true;

    return new Promise((resolve, reject) => {
        this.networkService.post('kernel/masters/productGet', request).then(response => {
            resolve(response.product)
        }, error => {
            reject(error);
        });
    });
}

  productSave(product : Product) : Promise<Product>{
      let request : ProductRequest = new ProductRequest(this.userService.userInfo);
      request.product = product;
  
      return new Promise((resolve, reject) => {
          this.networkService.post('kernel/masters/productSave', request).then(result => {                
              let product : Product = result.product;
              return resolve(product);  

          }, error => {
              reject(error);
          });
      });
  }

  productApprove(productCode : string) : Promise<Product>{
      let request : BaseRequest = new BaseRequest(this.userService.userInfo);
      request.strArg1 = productCode;
  
      return new Promise((resolve, reject) => {
          this.networkService.post('kernel/masters/productApprove', request).then(result => {                
              let product : Product = result.product;
              return resolve(product);  

          }, error => {
              reject(error);
          });
      });
  }


//------------------------------------------------------------------------------------
//                      PRODUCT OPTION
//------------------------------------------------------------------------------------
productOptionsGet(optionCode: string, productCategoryCode : string, productCategoryTypeCode : string): Promise<ProductOption[]> {
      let request: BaseRequest = new BaseRequest(this.userService.userInfo);
  
      request.strArg1 = optionCode;
      request.strArg2 = productCategoryCode;
      request.strArg3 = productCategoryTypeCode;
  
      return new Promise((resolve, reject) => {
          this.networkService.post('kernel/masters/productOptionsGet', request).then(result => {
              return resolve(result.productOptions);    
          }, error => {
              reject(error);
          });
      });
  }
  
  productOptionSave(productOption : ProductOption) : Promise<ProductOption>{
      let request : ProductOptionRequest = new ProductOptionRequest(this.userService.userInfo);
      request.productOption = productOption;
  
      return new Promise((resolve, reject) => {
          this.networkService.post('kernel/masters/productOptionSave', request).then(result => {
              let productOption : ProductOption ;
              if (result.productOptions) {
                  productOption = result.productOptions[0];
              }
              return resolve(productOption);            
          }, error => {
              reject(error);
          });
      });
  }  
//------------------------------------------------------------------------------------



//------------------------------------------------------------------------------------
//                      PRICE LIST
//------------------------------------------------------------------------------------
priceListsGet(priceListCode: string) : Promise<PriceList[]> {
      let request: BaseRequest = new BaseRequest(this.userService.userInfo);

      request.strArg1 = priceListCode;

      return new Promise((resolve, reject) => {
          this.networkService.post('kernel/masters/priceListsGet', request).then(response => {
              resolve(response.priceLists)
          }, error => {
              reject(error);
          });
      });
  }
  priceListGet(priceListCode: string, activeOnly : boolean): Promise<PriceList> {
    let request: BaseRequest = new BaseRequest(this.userService.userInfo);

    request.strArg1 = priceListCode;
    request.blnArg1 = activeOnly;

    return new Promise((resolve, reject) => {
        this.networkService.post('kernel/masters/priceListGet', request).then(response => {
            resolve(response.priceList)
        }, error => {
            reject(error);
        });
    });
}
  priceListSave(priceList : PriceList) : Promise<PriceList>{
      let request : PriceListRequest = new PriceListRequest(this.userService.userInfo);
      request.priceList = priceList;
  
      return new Promise((resolve, reject) => {
          this.networkService.post('kernel/masters/priceListSave', request).then(result => {                
              return resolve(result.priceList);  
          }, error => {
              reject(error);
          });
      });
  }

}

